import React from "react";
import classes from "./CardMain.module.scss";
import CardRegistration from "../../card/CardRegistration";
import { userState } from "../../../states/userState";
import { useRecoilValue } from "recoil";

import { theme } from "../../../theme/theme";
const CardMain = () => {
  const user = useRecoilValue(userState);
  return (
    <div className={classes.root} style={backgroundColor(user?.mode ?? "lite")}>
      <CardRegistration />
    </div>
  );
};

const backgroundColor = (mode: string) => {
  return {
    backgroundColor:
      mode === "lite"
        ? theme.palette.liteColor.backColor.main //間違いではない。色合いを考慮してdarkColorを指定している
        : theme.palette.darkColor.backColor.main,
  };
};
export default CardMain;
